module.exports = __webpack_public_path__ + "static/images/containers/BuildingCard/components/ReserveSelect/images/arrow.8eca0d52.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingCard/components/ReserveSelect/images/arrow.png
// module id = 2806
// module chunks = 11